<template>
  <v-container fluid grid-list-xl>
      <v-card class="elevation-0">
        <v-flex xs12 md12 class="elevation-0">
        <v-tabs v-model="tab" color="#E30E4F" background-color="lime-lighten-4">
          <v-tab v-for="item in items" :key="item.tab"  :disabled="item.valid">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item.tab" :disabled="item.status">
            <v-card flat>
              <v-card-text>
                <component v-bind:is="item.content"></component>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        </v-flex>
      </v-card>
    </v-container>
  </template>
  
  <script>
  import VIV from '../events/VIV';
  import SpecialEventReservation from './SpecialEventReservation.vue';
  import SpecialEvent from './SpecialEvent.vue';

  export default {
    components: {
      VIV,
      SpecialEventReservation,
      SpecialEvent
    },
    data() {
      return {
        isVisible: false,
        tab: null,
        items: [
          //{ tab: 'Neeya Naana', content: 'SpecialEvent'},
          //{ tab: 'Meet & Dine', content: 'SpecialEventReservation'},
          { tab: 'Vazhai Ilai Virundhu', content: 'VIV'},
        ]
      };
    }
  };
  </script>

  <style>
  .v-tab {
    text-transform: none !important;
    }
    .v-tabs-slider-wrapper {
    right: auto !important;
    right: 0;
  }
  </style>